import React from 'react';

const CSS = require('./ErrorLabel.module.scss');

interface ErrorLabelProps {
  children: any;
}

function ErrorLabel({ children }: ErrorLabelProps) {
  if (!children) {
    return null;
  }
  return (
    <label className={CSS.ErrorLabel} data-test-id="ErrorLabel">
      {children}
    </label>
  );
}

export default ErrorLabel;
